<template>
  <section id="ecosystem" class="ecosystem-section">
    <v-container class="section-container">
      <div class="section-header text-center">
        <span class="section-tag">Архитектура сервиса</span>
        <h2 class="section-title">Единая экосистема OZO.direct</h2>
        <p class="section-description">
          4 взаимосвязанных цифровых модуля объединяются в целостную платформу
          для управления продажами, сервисом в зале, доставкой и базой
          постоянных гостей.
        </p>

        <!-- Интерактивные табы модулей -->
        <div class="zone-selector mt-6">
          <button
            v-for="(zone, idx) in zones"
            :key="zone.id"
            class="zone-btn"
            :class="{ active: activeZoneIndex === idx }"
            @click="activeZoneIndex = idx"
          >
            <i :class="[zone.icon, 'zone-icon mr-1']"></i>
            <span>{{ zone.tabName }}</span>
          </button>
        </div>
      </div>

      <!-- Сетка 4 ключевых модулей экосистемы -->
      <v-row class="ecosystem-cards mt-8" align="stretch">
        <v-col
          v-for="(mod, idx) in modules"
          :key="mod.title"
          cols="12"
          sm="6"
          lg="3"
          class="ecosystem-col"
        >
          <div
            class="ecosystem-card"
            :class="{
              'card-active': activeZoneIndex === idx,
            }"
            @click="activeZoneIndex = idx"
          >
            <!-- Визуальный мокап модуля из презентации -->
            <div class="card-visual-box img-skeleton-box">
              <img
                :src="mod.image"
                :alt="mod.title"
                class="card-img"
                loading="lazy"
                @load="onImgLoad"
              />
            </div>

            <div class="card-body">
              <div class="card-header-row">
                <span class="card-badge">{{ mod.number }}</span>
                <span
                  class="zone-pill"
                  :class="{ 'green-pill': activeZoneIndex === idx }"
                >
                  {{ mod.pill }}
                </span>
              </div>

              <h3 class="card-title">{{ mod.title }}</h3>
              <p class="card-subtitle">{{ mod.subtitle }}</p>

              <ul class="card-list">
                <li v-for="(feat, fIdx) in mod.features" :key="fIdx">
                  <i class="ri-check-line bullet-check"></i>
                  <span>{{ feat }}</span>
                </li>
              </ul>
            </div>
          </div>
        </v-col>
      </v-row>

      <!-- Инфографическая плашка: Единый центр синхронизации (Диаграмма из слайда 3) -->
      <div class="ecosystem-banner mt-12">
        <v-row align="center" justify="space-between">
          <v-col cols="12" md="6" class="banner-text">
            <span class="banner-badge">Централизованная база</span>
            <h3 class="banner-title">
              Вся информация ресторана синхронизируется в реальном времени
            </h3>
            <p class="banner-desc">
              Изменения в меню, стоп-листы, новые акции и данные о гостях
              мгновенно обновляются одновременно на кассе, в приложениях гостей,
              в веб-меню и в отчетах OZO.OFFICE.
            </p>
            <div class="banner-stats">
              <div class="b-stat">
                <strong>4 языка</strong>
                <span>ИИ перевод меню</span>
              </div>
              <div class="b-stat">
                <strong>0% посредников</strong>
                <span>Оплата на ваш счет</span>
              </div>
              <div class="b-stat">
                <strong>7 дней</strong>
                <span>Срок запуска</span>
              </div>
            </div>
          </v-col>

          <v-col cols="12" md="5" class="banner-visual text-center">
            <div class="diagram-wrap img-skeleton-box">
              <img
                :src="require('@/assets/presentation/ecosystem-diagram.png')"
                alt="Архитектура OZO.direct"
                class="diagram-img"
                loading="lazy"
                @load="onImgLoad"
              />
            </div>
          </v-col>
        </v-row>
      </div>
    </v-container>
  </section>
</template>

<script>
export default {
  name: "EcosystemSection",
  data() {
    return {
      activeZoneIndex: 0,
      zones: [
        { id: "staff", tabName: "Ресторан", icon: "ri-smartphone-line" },
        { id: "guest", tabName: "Гость", icon: "ri-user-smile-line" },
        { id: "qr", tabName: "QR-меню", icon: "ri-qr-code-line" },
        { id: "office", tabName: "OZO.OFFICE", icon: "ri-dashboard-3-line" },
      ],
      modules: [
        {
          number: "01",
          pill: "Операции & Зал",
          title: "Приложение ресторана",
          subtitle: "Хаб для управляющего, кухни и официантов",
          image: require("@/assets/presentation/eco-restaurant.png"),
          features: [
            "Управление меню и стоп-листами в реальном времени",
            "Встроенный ИИ для перевода меню на 4 языка",
            "Мониторинг заказов и управление доставкой",
            "Электронный журнал бронирования столов",
            "Мгновенные уведомления об отзывах гостей",
          ],
        },
        {
          number: "02",
          pill: "LTV & Лояльность",
          title: "Приложение гостя",
          subtitle: "Фирменное приложение вашего заведения на iOS и Android",
          image: require("@/assets/presentation/eco-guest.png"),
          features: [
            "Оплата заказов в зале и на доставку в 1 клик",
            "Кэшбэк, бонусные баллы и скидки",
            "Интерактивные сторис и умные купоны",
            "История заказов и повтор любимых блюд",
            "Онлайн-бронирование столов без комиссий",
          ],
        },
        {
          number: "03",
          pill: "Без установки",
          title: "QR-веб-меню",
          subtitle: "Мгновенный просмотр меню и заказ со смартфона",
          image: require("@/assets/presentation/eco-qr.png"),
          features: [
            "Открытие меню за 1 секунду по QR без скачивания",
            "Меню на любом языке для туристов и гостей",
            "Бесконтактный заказ и оплата со стола",
            "Ссылка на установку приложения с бонусом",
            "Единая база меню на сайте и в приложении",
          ],
        },
        {
          number: "04",
          pill: "Бизнес-аналитика",
          title: "Панель OZO.OFFICE",
          subtitle: "Управленческий учет и аналитика гостевой базы",
          image: require("@/assets/presentation/eco-office.png"),
          features: [
            "RFM-сегментация базы (LTV, частота, средний чек)",
            "Анализ выручки по каналам (зал, доставка, навынос)",
            "ABC-анализ прибыльности и популярности блюд",
            "Наглядные интерактивные дэшборды",
            "Экспорт данных и синхронизация с кассой",
          ],
        },
      ],
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.$el.querySelectorAll(".card-img, .diagram-img").forEach((img) => {
        if (img.complete && img.naturalWidth > 0) {
          img.classList.add("is-loaded");
          if (img.parentElement) img.parentElement.classList.add("is-loaded");
        }
      });
    });
  },
  methods: {
    onImgLoad(e) {
      if (e && e.target) {
        e.target.classList.add("is-loaded");
        if (e.target.parentElement) {
          e.target.parentElement.classList.add("is-loaded");
        }
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/styles/_variables.scss";

.ecosystem-section {
  background-color: $color-bg-light;
  padding: $section-py 0;
  position: relative;

  @media (max-width: 960px) {
    padding: $section-py-mobile 0;
  }
}

.section-container {
  max-width: $container-max-width;
  margin: 0 auto;
}

.section-tag {
  display: inline-block;
  color: #0b7a3a;
  background: $color-neon-green-soft;
  font-size: 13px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  padding: 6px 14px;
  border-radius: $radius-full;
  margin-bottom: 12px;
}

.section-title {
  font-family: $font-family-heading;
  font-size: 38px;
  font-weight: 800;
  color: $color-text-dark;
  margin-bottom: 16px;
  letter-spacing: -0.01em;

  @media (max-width: 960px) {
    font-size: 28px;
  }
}

.section-description {
  font-size: 16px;
  color: $color-text-secondary;
  max-width: 720px;
  margin: 0 auto;
  line-height: 1.6;
}

.zone-selector {
  display: inline-flex;
  background: #e2e8f0;
  padding: 4px;
  border-radius: $radius-full;
  flex-wrap: wrap;
  justify-content: center;

  @media (max-width: 480px) {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 4px;
    border-radius: $radius-md;
    width: 100%;
  }

  .zone-btn {
    border: none;
    background: transparent;
    padding: 8px 20px;
    border-radius: $radius-full;
    font-size: 13px;
    font-weight: 600;
    color: #475569;
    cursor: pointer;
    transition: all 0.25s ease;

    @media (max-width: 480px) {
      border-radius: $radius-sm;
      padding: 8px 6px;
      font-size: 12px;
      text-align: center;
    }

    &.active {
      background: #ffffff;
      color: $color-text-dark;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
      font-weight: 700;
    }
  }
}

.ecosystem-cards {
  display: flex;
}

.ecosystem-col {
  display: flex;
}

.ecosystem-card {
  background: $color-bg-white;
  border-radius: $radius-lg;
  overflow: hidden;
  width: 100%;
  border: 1.5px solid #eef0f3;
  box-shadow: $shadow-card;
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  cursor: pointer;

  &:hover {
    transform: translateY(-6px);
    box-shadow: $shadow-hover;
    border-color: rgba(0, 230, 118, 0.5);
  }

  &.card-active {
    border-color: #00e676;
    box-shadow: 0 12px 30px rgba(0, 230, 118, 0.18);
    background: linear-gradient(180deg, #ffffff 0%, #f4fbf7 100%);
    transform: translateY(-4px);

    .card-badge {
      background: rgba(0, 230, 118, 0.15);
      color: #0b7a3a;
    }
  }

  .card-visual-box {
    background: #f8fafc;
    padding: 18px;
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 180px;
    border-bottom: 1px solid #f1f5f9;

    .card-img {
      max-width: 100%;
      max-height: 160px;
      object-fit: contain;
      transition: transform 0.3s ease;
    }
  }

  &:hover .card-img {
    transform: scale(1.04);
  }

  .card-body {
    padding: 24px 20px;
    display: flex;
    flex-direction: column;
    flex-grow: 1;
  }
}

.card-header-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 14px;
}

.card-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: $radius-sm;
  background: #f1f5f9;
  font-weight: 800;
  font-size: 13px;
  color: $color-graphite;
}

.zone-pill {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  background: #f1f5f9;
  color: #64748b;
  padding: 4px 10px;
  border-radius: $radius-full;

  &.green-pill {
    background: rgba(0, 230, 118, 0.2);
    color: #0b7a3a;
  }
}

.card-title {
  font-family: $font-family-heading;
  font-size: 18px;
  font-weight: 800;
  color: $color-text-dark;
  margin-bottom: 6px;
}

.card-subtitle {
  font-size: 12px;
  color: $color-text-secondary;
  margin-bottom: 18px;
  min-height: 34px;
  line-height: 1.4;
}

.card-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;

  li {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    font-size: 12px;
    line-height: 1.4;
    color: $color-text-dark;

    .bullet-check {
      color: #0ebd60;
      font-weight: 800;
      flex-shrink: 0;
    }
  }
}

/* Ecosystem Banner */
.ecosystem-banner {
  background: $color-graphite-dark;
  color: #ffffff;
  border-radius: $radius-lg;
  padding: 40px;
  border: 1px solid rgba(255, 255, 255, 0.08);

  @media (max-width: 600px) {
    padding: 24px 20px;
  }

  @media (max-width: 480px) {
    padding: 20px 16px;
  }

  .banner-badge {
    display: inline-block;
    color: $color-neon-green;
    font-size: 12px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    margin-bottom: 12px;
  }

  .banner-title {
    font-family: $font-family-heading;
    font-size: 26px;
    font-weight: 800;
    line-height: 1.25;
    margin-bottom: 14px;
    color: #ffffff;

    @media (max-width: 480px) {
      font-size: 21px;
    }
  }

  .banner-desc {
    font-size: 14px;
    color: #94a3b8;
    line-height: 1.6;
    margin-bottom: 24px;
  }

  .banner-stats {
    display: flex;
    gap: 24px;
    flex-wrap: wrap;

    @media (max-width: 480px) {
      gap: 16px;
      justify-content: space-between;
    }

    .b-stat {
      display: flex;
      flex-direction: column;

      strong {
        font-family: $font-family-heading;
        font-size: 18px;
        color: $color-neon-green;

        @media (max-width: 480px) {
          font-size: 16px;
        }
      }

      span {
        font-size: 12px;
        color: #cbd5e1;

        @media (max-width: 480px) {
          font-size: 11px;
        }
      }
    }
  }

  .diagram-wrap {
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: $radius-md;

    &.img-skeleton-box::before {
      background: linear-gradient(
        90deg,
        rgba(255, 255, 255, 0.05) 0%,
        rgba(255, 255, 255, 0.15) 50%,
        rgba(255, 255, 255, 0.05) 100%
      );
    }

    .diagram-img {
      max-width: 100%;
      max-height: 260px;
      object-fit: contain;
      filter: drop-shadow(0 10px 24px rgba(0, 230, 118, 0.15));
    }
  }
}
</style>
